//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { PinnedMediaToolbarAction } from '@galleries/actions/pinnedMediaToolbarActions';
import { PINNED_MEDIA_TOOLBAR_ACTIONS } from '@galleries/constants/galleriesConstants';
import { IPinnedMediaToolbarState } from '@galleries/models/pinnedMediaToolbarModel';
import { PojoSet } from 'pojo-sets';

const initialState: IPinnedMediaToolbarState = {
  openContexts: {},
};

export default function PinnedMediaToolbarReducer(
  state: IPinnedMediaToolbarState = initialState,
  action: PinnedMediaToolbarAction,
): IPinnedMediaToolbarState {
  switch (action.type) {
    case PINNED_MEDIA_TOOLBAR_ACTIONS.OPEN_TOOLBAR: {
      return {
        ...state,
        openContexts: PojoSet.add(state.openContexts, action.context),
      };
    }
    case PINNED_MEDIA_TOOLBAR_ACTIONS.CLOSE_TOOLBAR: {
      return {
        ...state,
        openContexts: PojoSet.remove(state.openContexts, action.context),
      };
    }
    default: {
      return state;
    }
  }
}
